import { render } from "./partsUsage.vue?vue&type=template&id=a527bb7c"
import script from "./partsUsage.vue?vue&type=script&lang=js"
export * from "./partsUsage.vue?vue&type=script&lang=js"

import exportComponent from "/container/application/releases/20260729235012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__